/**
 * Created by Michael Pittner on 16.08.2017.
 */

const delete_alert_input = document.getElementById("delete_alert_input");
const cancel_alert_input = document.getElementById("cancel_alert_input");
const success_alert_input = document.getElementById("success_alert_input");
const try_again_alert_input = document.getElementById("try_again_alert_input");
const apply_alert_input_input = document.getElementById("apply_alert_input");
const yes_alert_input = document.getElementById("yes_alert_input");
const no_alert_input = document.getElementById("no_alert_input");


function closeAlert() {
    document.getElementsByTagName("body")[0].style.overflow = "";
    disable_background();
}


const ALERTTYPE = {
    normal: 1,
    msg_read: 2,
    yes_no: 3,
    accept: 4,
    //not_cloable: 5,
    //password: 6,
    delete: 7,
    error: 8,
    unsubscribe: 9,
    yes_no_error: 10,
    opt1_opt2_cancel: 11,
};

/**
 * The
 * createAlertBoxWithTwoEventListeners
 *  function is responsible for creating an alert box with two buttons, an image, and event listeners attached to the buttons. Here's a breakdown of what the code does:
 *
 * The function takes several parameters, including the source of the image (`img_src`), the text for the two buttons (`btn1Txt` and `btn2Txt`), container elements (`bottomContainer`, `img_element`, `button_img_div`, and `button_element`), callback functions for the button click events (`event_listener_no` and `event_listener_yes`), optional parameters for the callback functions (`event_yes_params` and `event_no_params`), and a boolean flag to indicate if the alert is an error (`isError`).
 * It creates three new HTML elements: `button_cancel` (a div for the cancel button), `button_success` (a div for the success button), and `img` (an image element).
 * It sets the `src` attribute of the `img` element to the provided `img_src` value.
 * It appends the `img` element to the `img_element` container.
 * It adds CSS classes to the button elements (`btn-grey` for `button_cancel`, `btn` for `button_success`, and either `btn-green` or `btn-red` for `button_success` depending on the `isError` flag).
 * It sets the `id` attribute of `button_success` to `"btn_success"`.
 * It sets the width of `button_cancel` to `"146px"`.
 * It attaches an event listener to `button_cancel` that calls the `event_listener_no` function with either the `event_no_params` value or the event object (`el`) as a parameter, depending on whether `event_no_params` is defined or not.
 * It attaches an event listener to `button_success` that calls the `event_listener_yes` function with either the `event_yes_params` value or the event object (`el`) as a parameter, depending on whether `event_yes_params` is defined or not.
 * It sets the width of `bottomContainer` to `"100%"`.
 * It sets various styles for `button_img_div`, including `display`, `whiteSpace`, `textAlign`, `minWidth`, and `width`.
 * It adds CSS classes `modal-block` and `modal-btn` to `bottomContainer`.
 * It appends `button_cancel`, `button_success`, and `button_img_div` to `bottomContainer`.
 * It appends `bottomContainer` to `button_element`.
 * Finally, it sets the `innerText` of `button_cancel` to `btn1Txt` and the `innerText` of `button_success` to `btn2Txt`.
 * In summary, this function creates an alert box with two buttons, an image, and event listeners attached to the buttons. The appearance and behavior of the alert box can be customized through the function parameters.
 *
 * @param img_src
 * @param btn1Txt
 * @param btn2Txt
 * @param bottomContainer
 * @param event_listener_no
 * @param event_listener_yes
 * @param img_element
 * @param button_img_div
 * @param button_element
 * @param event_yes_params
 * @param event_no_params
 * @param isError
 */
function createAlertBoxWithTwoEventListeners(img_src, btn1Txt, btn2Txt, bottomContainer, event_listener_no,
                                             event_listener_yes, img_element, button_img_div, button_element, event_yes_params = undefined, event_no_params = undefined, isError = false) {
    const button_cancel = document.createElement("div");
    const button_success = document.createElement("div");
    const img = document.createElement("img");
    let yes_params = event_yes_params;
    let no_params = event_no_params;

    img.src = img_src// "/images/alert/alert_ok.png";

    img_element.appendChild(img);

    button_cancel.classList.add("btn-grey");
    button_success.classList.add("btn");

    if (isError === false)
        button_success.classList.add("btn-green");
    else
        button_success.classList.add("btn-red");

    button_success.id = "btn_success";

    button_cancel.style.width = "146px";

    button_cancel.onclick = (function (el) {
        if (no_params !== undefined)
            event_listener_no(no_params);
        else
            event_listener_no(el);
    });

    button_success.onclick = (function (el) {
        if (yes_params !== undefined)
            event_listener_yes(yes_params);
        else
            event_listener_yes(el);
    });

    bottomContainer.style.width = "100%";

    button_img_div.style.display = "inline-block";
    button_img_div.style.whiteSpace = "nowrap";

    button_img_div.style.textAlign = "right";
    button_img_div.style.minWidth = "0px";
    button_img_div.style.width = "0px";

    bottomContainer.classList.add("modal-block");
    bottomContainer.classList.add("modal-btn");

    bottomContainer.appendChild(button_cancel);
    bottomContainer.appendChild(button_success);
    //bottomContainer.appendChild(button_img_div);
    button_element.appendChild(bottomContainer);
    /* *************************** */

    button_cancel.innerText = btn1Txt//no_alert_input.value;
    button_success.innerText = btn2Txt//yes_alert_input.value;
}

function createAlertBoxWithThreeEventListeners(img_src, btn1Txt, btn2Txt, cancelTxt, bottomContainer, event_listener_opt1,
                                               event_listener_opt2, event_listener_cancel, img_element, button_img_div, button_element, event_opt1_params = undefined, event_opt2_params = undefined, event_cancel_params = undefined) {
    const button_cancel = document.createElement("div");
    const button_opt1 = document.createElement("div");
    const button_opt2 = document.createElement("div");
    const img = document.createElement("img");
    let opt1_params = event_opt1_params;
    let opt2_params = event_opt2_params;
    let cancel_params = event_cancel_params;

    img.src = img_src;

    img_element.appendChild(img);

    button_cancel.classList.add("btn");
    button_cancel.classList.add("btn-grey");
    button_opt1.classList.add("btn");
    button_opt2.classList.add("btn");
    button_opt1.classList.add("btn-green");
    button_opt2.classList.add("btn-red");

    button_opt1.style.width = "167px";
    button_opt2.style.width = "167px!important";

    button_opt1.id = "btn_opt1";
    button_opt2.id = "btn_opt2";

    //button_cancel.style.width = "146px";

    button_cancel.style.marginTop = "10px";
    button_cancel.style.width = "100%";

    button_cancel.onclick = (function (el) {
        if (cancel_params !== undefined)
            event_listener_cancel(cancel_params);
        else
            event_listener_cancel(el);
    });

    button_opt1.onclick = (function (el) {
        if (opt1_params !== undefined)
            event_listener_opt1(opt1_params);
        else
            event_listener_opt1(el);
    });

    button_opt2.onclick = (function (el) {
        if (opt2_params !== undefined)
            event_listener_opt2(opt2_params);
        else
            event_listener_opt2(el);
    });

    bottomContainer.style.width = "100%";

    button_img_div.style.display = "inline-block";
    button_img_div.style.whiteSpace = "nowrap";

    button_img_div.style.textAlign = "right";
    button_img_div.style.minWidth = "0px";
    button_img_div.style.width = "0px";

    bottomContainer.classList.add("modal-block");
    bottomContainer.classList.add("modal-btn");

    bottomContainer.appendChild(button_opt1);
    bottomContainer.appendChild(button_opt2);
    bottomContainer.appendChild(button_cancel);
    //bottomContainer.appendChild(button_img_div);
    button_element.appendChild(bottomContainer);
    /* *************************** */

    button_opt1.innerText = btn1Txt;
    button_opt2.innerText = btn2Txt;
    button_cancel.innerText = cancelTxt;
}

/**
 *
 * openAlert um Alerts zu öffnen, die alle gleich ausschauen
 * typ 1 - normaler alert - lediglich meldung
 * typ 2 - "Nachricht gelesen und zur Kenntnis genommen"
 * typ 3 - "Ja / Nein" mit Event Listener
 * typ 4 - Input - "Bestätigen - Abbrechen" hier ist event_no_params der placeholder des textfeldes
 * typ 5 - Nicht schließbarer Alert
 * typ 6 - Alert mit Passwortfeld (typ 2 modifiziert)
 * typ 7 - Löschen mit Auswahlmöglichkeit Löschen/ Abbrechen
 * typ 8 - Warnung das ein Fehler aufgetreten ist
 * TODO: Buttons redesignen
 *
 *
 * title = Titel der Meldung
 * text = Inhalt der Meldung
 * disable_close = wenn 1, kann man nicht mit ESC/neben dem Alert klicken schliessen, sonst schon
 * menu = nichts derzeit
 * event_listener_yes = wenn typ 3/4 dann muss gegeben sein - dann wird die funktionion bei Ja/Bestätigen aufgerufen
 * event_listener_no = wenn typ 3, dann wird bei nein die function ausgeführt
 * event_yes_params = parameter bei typ 3/4 die an die funktion übergeben werden (bei 4 ist der 1 param das obj, der 2 param das textfeld (el)
 * event_no_params = parameter d. function bei typ 3, bei typ 4 = placeholder
 *
 * */
function openAlertFunction(title, text, type, disable_close, menu, event_listener_yes, event_listener_no, event_yes_params, event_no_params, shaddow_element, title_element, text_element, button_element, close_function, img_element, opt_params, opt1_txt, opt2_txt, cancel_txt, event_listener_cancel) {
    //console.log(opt_params);

    if (Object.prototype.toString.call(title) === '[object Object]') {
        text = title.text;
        type = title.type;
        disable_close = title.disable_close;
        menu = title.menu;
        event_listener_yes = title.event_listener_yes;
        event_listener_no = title.event_listener_no;
        event_yes_params = title.event_yes_params;
        event_no_params = title.event_no_params;
        title = title.title;
    }

    img_element.innerHTML = "";

    var alert_object;
    if (disable_close === undefined) {
        disable_close = -1;
    }
    if (menu === undefined) {
        menu = 0;
    }

    // prevent closing on click on alert
    img_element.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
    });
    title_element.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
    });
    text_element.addEventListener("click", function (event) {
        if (event.target.id === "input_deregistration") {
            // event.preventDefault();
            event.stopPropagation();
        } else {
            event.preventDefault();
            event.stopPropagation();
        }
    });
    button_element.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
    });

    if (menu === 0)
        shaddow_element.className = "shaddow_without_menu";
    else
        shaddow_element.className = "shaddow_with_menu";


    var bottomContainer = document.createElement('div');
    var button_text_div = document.createElement('div');
    var button_img_div = document.createElement('div');

    button_element.innerHTML = "";
    button_text_div.innerHTML = "";
    button_img_div.innerHTML = "";

    var current_pos = -1;
    var max_pos = -1;
    var title_arr, text_arr, type_arr;

    if (Object.prototype.toString.call(type) === '[object Array]') {
        current_pos = 0;
        if (title.length - 1 === text.length) {
            current_pos = title[0];
            title.shift();
        }

        if (title.length !== text.length && title.length !== type.length)
            return;

        if (current_pos + 1 > title.length)
            return;

        max_pos = title.length;

        title_arr = title;
        text_arr = text;
        type_arr = type;

        title = title_arr[current_pos] + " (" + (current_pos + 1) + "/" + max_pos + ")";
        text = text_arr[current_pos];
        type = type_arr[current_pos];

    }

    /**
     * normal
     */
    if (type === 1) {
        /* create BottomContainer */
        const button_cancel = document.createElement("div");
        const button_success = document.createElement("div");
        const img = document.createElement("img");

        img.src = "/images/alert/alert_ok.png";

        img_element.appendChild(img);

        button_cancel.classList.add("btn-grey");
        button_success.classList.add("btn");
        button_success.classList.add("btn-green");

        button_cancel.style.width = "146px";

        button_cancel.onclick = (function (el) {
            disable_background();
        });

        button_success.onclick = (function (el) {
            if (close_function instanceof Function) {
                close_function();
            } else {
                closeAlert();
            }
        });

        bottomContainer.style.width = "100%";

        button_img_div.style.display = "inline-block";
        button_img_div.style.whiteSpace = "nowrap";

        button_img_div.style.textAlign = "right";
        button_img_div.style.minWidth = "0px";
        button_img_div.style.width = "0px";

        bottomContainer.classList.add("modal-block");
        bottomContainer.classList.add("modal-btn");

        bottomContainer.appendChild(button_cancel);
        bottomContainer.appendChild(button_success);
        //bottomContainer.appendChild(button_img_div);
        button_element.appendChild(bottomContainer);
        /* *************************** */

        button_cancel.innerText = cancel_alert_input.value;
        button_success.innerText = success_alert_input.value;
    }

    /**
     * msg_read
     */
    if (type === 2) {

        if (disable_close === -1)
            disable_close = 1;

        const button_success = document.createElement("div");
        const img = document.createElement("img");

        img.src = "/images/alert/alert_ok.png";

        img_element.appendChild(img);

        button_success.classList.add("btn");
        button_success.classList.add("btn-green");
        button_success.style.width = "100%";


        button_success.onclick = (function (el) {
            if (close_function instanceof Function) {
                close_function();
            } else {
                closeAlert();
            }
        });

        bottomContainer.style.width = "100%";

        button_img_div.style.display = "inline-block";
        button_img_div.style.whiteSpace = "nowrap";

        button_img_div.style.textAlign = "right";
        button_img_div.style.minWidth = "0px";
        button_img_div.style.width = "0px";

        bottomContainer.classList.add("modal-block");
        bottomContainer.classList.add("modal-btn");

        bottomContainer.appendChild(button_success);
        //bottomContainer.appendChild(button_img_div);
        button_element.appendChild(bottomContainer);
        /* *************************** */

        button_success.innerText = "Nachricht gelesen und zur Kenntnis genommen.";//success_alert_input.value;
    }

    if (type === ALERTTYPE.yes_no) {
        createAlertBoxWithTwoEventListeners("/images/alert/alert_ok.png", no_alert_input.value, yes_alert_input.value,
            bottomContainer, event_listener_no,
            event_listener_yes, img_element, button_img_div, button_element, event_yes_params, undefined);
    }

    if (type === 4) {
        createAlertBoxWithTwoEventListeners("/images/alert/alert_ok.png", cancel_alert_input.value, apply_alert_input_input.value,
            bottomContainer, event_listener_no,
            event_listener_yes, img_element, button_img_div, button_element);
    }

    if (type === 5) {

        disable_close = 1;

        /* create BottomContainer */

    }

    if (type === 6) {

        if (disable_close === -1)
            disable_close = 1;

        /* create error div to show pw error and append to text div */

        var div_error_pw_outer = document.createElement("div");
        var div_error_pw = document.createElement("div");
        div_error_pw.innerHTML = "";
        div_error_pw.id = "div_error_pw";
        div_error_pw.className = "div_error_pw";
        div_error_pw_outer.appendChild(div_error_pw);
        text = div_error_pw_outer.innerHTML + text;

        /* create BottomContainer */

        var password_div = document.createElement("div");
        var password_input = document.createElement("input");
        password_input.type = "password";
        password_input.placeholder = "Ihr Passwort";
        password_input.className = "password_input";

        // prevent closing on clicking on textbox
        password_input.addEventListener("click", function () {
            event.preventDefault();
            event.stopPropagation();
        });
        password_input.addEventListener("keydown", function (e) {
            if (13 == e.keyCode) {
                test_password(password_input, 'div_error_pw', event_listener_yes, event_yes_params, event_listener_no, event_no_params);
            }
        });

        password_div.appendChild(password_input);

        bottomContainer.style.width = "100%";
        bottomContainer.style.height = "40px";
        text_element.style.height = "110px";

        button_text_div.style.display = "inline-block";
        button_text_div.style.whiteSpace = "nowrap";
        button_img_div.style.display = "inline-block";
        button_img_div.style.whiteSpace = "nowrap";

        button_text_div.style.textAlign = "left";
        button_img_div.style.textAlign = "right";
        button_text_div.style.minWidth = "350px";
        button_img_div.style.minWidth = "35px";
        button_text_div.style.width = "350px";
        button_img_div.style.width = "35px";

        bottomContainer.appendChild(password_div);
        bottomContainer.appendChild(button_text_div);
        bottomContainer.appendChild(button_img_div);
        button_element.appendChild(bottomContainer);
        /* *************************** */

        let img = document.createElement("img");
        img.style.width = "18px";
        img.style.cursor = "pointer";
        img.src = "/pictures/hackerl_weiss.png";
        img.addEventListener("click", function () {
            test_password(password_input, 'div_error_pw', event_listener_yes, event_yes_params, event_listener_no, event_no_params);
            event.preventDefault();
            event.stopPropagation();
        });

        button_img_div.appendChild(img);
        button_text_div.innerHTML = "Nachricht gelesen und zur Kenntnis genommen.";
    }

    if (type === 7) {
        const button_cancel = document.createElement("div");
        const button_delete = document.createElement("div");
        const img = document.createElement("img");

        img.src = "/images/alert/alert_delete.png";

        img_element.appendChild(img);

        button_cancel.classList.add("btn-grey");
        button_delete.classList.add("btn");
        button_delete.classList.add("btn-red");

        button_cancel.style.width = "146px";

        button_cancel.onclick = (function (el) {
            disable_background();
        });

        button_delete.onclick = (function (el) {
            if (event_listener_yes instanceof Function) {
                event_listener_yes(event_yes_params);
            } else {
                closeAlert();
            }
        });

        bottomContainer.style.width = "100%";

        button_img_div.style.display = "inline-block";
        button_img_div.style.whiteSpace = "nowrap";

        button_img_div.style.textAlign = "right";
        button_img_div.style.minWidth = "0px";
        button_img_div.style.width = "0px";

        bottomContainer.classList.add("modal-block");
        bottomContainer.classList.add("modal-btn");

        bottomContainer.appendChild(button_cancel);
        bottomContainer.appendChild(button_delete);
        //bottomContainer.appendChild(button_img_div);
        button_element.appendChild(bottomContainer);
        /* *************************** */

        button_cancel.innerText = cancel_alert_input.value;
        button_delete.innerText = delete_alert_input.value;
    }

    if (type === 8) {
        const button_try_again = document.createElement("div");
        const img = document.createElement("img");

        img.src = "/images/alert/alert_x.png";

        img_element.appendChild(img);

        button_try_again.classList.add("btn");
        button_try_again.classList.add("btn-red");
        button_try_again.classList.add("btn-red-error");

        button_try_again.onclick = (function (el) {
            if (event_listener_yes instanceof Function) {
                event_listener_yes();
            } else {
                closeAlert();
            }
        });

        bottomContainer.style.width = "100%";

        button_img_div.style.display = "inline-block";
        button_img_div.style.whiteSpace = "nowrap";

        button_img_div.style.textAlign = "right";
        button_img_div.style.minWidth = "0px";
        button_img_div.style.width = "0px";

        bottomContainer.classList.add("modal-block");
        bottomContainer.classList.add("modal-btn");

        bottomContainer.appendChild(button_try_again);
        //bottomContainer.appendChild(button_img_div);
        button_element.appendChild(bottomContainer);
        /* *************************** */

        button_try_again.innerText = try_again_alert_input.value;
    }

    if (type === 9) {
        //document.getElementById("alert_div").style.setProperty("height", "auto", "important");// = "100% !important";
        //document.getElementById("alert_div").style.setProperty("top", "calc(50% - 400px)", "important");
        //document.getElementById("alert_div_text").style.setProperty("height", "auto", "important");
        //document.getElementById("alert_div_text").style.setProperty("overflow", "scroll", "important");
        //document.getElementById("alert_div_buttons").style.setProperty("height", "auto", "important");
        //document.getElementById("alert_div_buttons").style.setProperty("margin-top","-60px", "important");

        createAlertBoxWithTwoEventListeners("/images/alert/alert_unsubscribe.png", no_alert_input.value, yes_alert_input.value,
            bottomContainer, event_listener_no,
            event_listener_yes, img_element, button_img_div, button_element);
    }

    if (type === ALERTTYPE.yes_no_error) {
        createAlertBoxWithTwoEventListeners("/images/alert/alert_x.png", no_alert_input.value, yes_alert_input.value,
            bottomContainer, event_listener_no,
            event_listener_yes, img_element, button_img_div, button_element, event_yes_params, undefined, true);
    }

    if (type === ALERTTYPE.opt1_opt2_cancel) {
        createAlertBoxWithThreeEventListeners("/images/alert/ask.png", opt1_txt, opt2_txt, cancel_txt,
            bottomContainer, event_listener_yes,
            event_listener_no, event_listener_cancel, img_element, button_img_div, button_element, event_yes_params, event_no_params);
    }


    if (disable_close == -1)
        disable_close = 0;


    if (disable_close == 0)
        shaddow_element.onclick = function () {
            disable_background()
        };
    else {
        shaddow_element.onclick = "";
    }

    title_element.innerHTML = title;

    if (current_pos != -1) {

        title_element.innerHTML = "";

        var full = document.createElement("div");

        var left = document.createElement("div");
        left.style.textAlign = "left";
        left.style.width = "20px";
        left.style.display = "inline";
        var centerEl = document.createElement("div");
        centerEl.style.textAlign = "center";
        centerEl.innerHTML = title;
        centerEl.style.width = "360px";
        centerEl.style.display = "inline";
        var right = document.createElement("div");
        right.style.textAlign = "right";
        right.style.width = "20px";
        right.style.display = "inline";

        full.appendChild(left);
        full.appendChild(centerEl);
        full.appendChild(right);

        var obj = {};
        obj.title = title_arr;
        obj.text = text_arr;
        obj.type = type_arr;
        obj.disable_close = disable_close;
        obj.menu = menu;
        obj.event_listener_yes = event_listener_yes;
        obj.event_listener_no = event_listener_no;
        obj.event_yes_params = event_yes_params;
        obj.event_no_params = event_no_params;


        if (current_pos != 0) {
            var o = document.createElement("img");
            o.src = '/pictures/icons/arrow_left.png';
            o.style = 'height:20px';

            o.onclick = function () {
                obj.title.unshift(current_pos - 1);
                openAlert(obj);
                event.stopPropagation(); // prevent to call onclick on upper element!
            };

            left.appendChild(o);
        }


        if (current_pos + 1 != max_pos) {
            var o2 = document.createElement("img");
            o2.src = '/pictures/icons/arrow_right.png';
            o2.style = 'height:20px';

            o2.onclick = function () {
                obj.title.unshift(current_pos + 1);
                openAlert(obj);
                event.stopPropagation(); // prevent to call onclick on upper element!
            };

            right.appendChild(o2);
        }
        title_element.append(full);
    }


    text_element.innerHTML = text;

    if (type === 9) {


        text_element.style.height = "auto";
        text_element.innerHTML += "<div style='width: 100%; margin-top: 0' class=\"form-group form-group-vacation styled\">\n" +
            "        <label>" + opt_params.str.deregistration + "</label>\n" +
            "        <input type=\"date\" value='" + opt_params.selected_date + "' oninput='requestToGetLastDateData()' autocomplete='false' id=\"input_deregistration\" size=\"30\" required pattern=\"\\d{4}-\\d{2}-\\d{2}\">\n" +
            "      </div><br>" +

            opt_params.unsubscribe_select +
            "      <br>" +
            opt_params.str.saldo_description + "";

        text_element.innerHTML += "</br><div>" +
            "<div class='unsubscribe-stats'><p>" + opt_params.str.hours_plain + "</p><p>" + opt_params.plusstunden + " h</p></div>" +
            "<div class='unsubscribe-stats'><p>" + opt_params.str.vacation_plain + "</p><p>" + opt_params.urlaub_plain + " " + opt_params.str.days + "</p></div>" +
            "<div class='unsubscribe-stats'><p>" + opt_params.str.ang_stunden + "</p><p>" + opt_params.ang_stunden + " h</p></div>" +
            "<div class='unsubscribe-stats'><p>" + opt_params.str.ang_tage + "</p><p>" + opt_params.ang_tage + " d</p></div>" +
            "</div>"

        //  document.getElementById("alert_div_buttons").style.marginTop = "-40px";
        document.getElementById("btn_success").classList.remove("btn-green");
        document.getElementById("btn_success").classList.add("btn-red");
        $('#unsubscribe_reason').each(initSelect); // openSettings
        document.getElementById("unsubscribe_reason").parentElement.children[2].style.top = "auto";
        document.getElementById("unsubscribe_reason").parentElement.children[2].style.width = 'calc(100% - 20px)';
        document.getElementById("unsubscribe_reason").parentElement.children[2].style.margin = '20px';
        document.getElementById("alert_div_buttons").children[0].style.marginTop = '1px';
    }

    shaddow_element.style.display = '';
}

function openAlert(title, text, type, disable_close, menu, event_listener_yes, event_listener_no, event_yes_params, event_no_params, opt_params = undefined) {

    var shaddow_element = document.getElementById('background_shaddow');
    var img_element = document.getElementById("alert_div_img");
    var title_element = document.getElementById('alert_div_title');
    var text_element = document.getElementById('alert_div_text');
    var button_element = document.getElementById('alert_div_buttons');

    openAlertFunction(title, text, type, disable_close, menu, event_listener_yes, event_listener_no, event_yes_params, event_no_params, shaddow_element, title_element, text_element, button_element, "disable_background", img_element, opt_params)

}

function openAlert3Options(title, text, event_listener_opt1, event_opt1_params, event_listener_opt2, event_opt2_params, event_listener_cancel, event_cancel_params, opt1_txt, opt2_txt, cancel_txt, opt_params = undefined) {

    let shaddow_element = document.getElementById('background_shaddow');
    let img_element = document.getElementById("alert_div_img");
    let title_element = document.getElementById('alert_div_title');
    let text_element = document.getElementById('alert_div_text');
    let button_element = document.getElementById('alert_div_buttons');

    openAlertFunction(title, text, ALERTTYPE.opt1_opt2_cancel, true, false, event_listener_opt1, event_listener_opt2, event_opt1_params, event_opt2_params, shaddow_element, title_element, text_element, button_element, "disable_background", img_element, opt_params, opt1_txt, opt2_txt, cancel_txt, event_listener_cancel)

}

var full_alert_is_open = false;

function openFullAlert(title, text, type, disable_close, menu, event_listener_yes, event_listener_no, event_yes_params, event_no_params) {

    full_alert_is_open = true;

    var shaddow_element = document.getElementById('background_shaddow_2');
    var title_element = document.getElementById('full_alert_div_title');
    var text_element = document.getElementById('full_alert_div_text');
    var button_element = document.getElementById('full_alert_div_buttons');

    openAlertFunction(title, text, type, disable_close, menu, event_listener_yes, event_listener_no, event_yes_params, event_no_params, shaddow_element, title_element, text_element, button_element, "disable_background_full")

}


function openInfo(text, duration, title) {
    if (duration == undefined) duration = 2;
    if (title == undefined) title = "Info";

    var shaddow_element = document.getElementById('info_shaddow_box');
    var title_element = document.getElementById('info_div_title');
    var text_element = document.getElementById('info_div_text');


    title_element.innerHTML = title;
    text_element.innerHTML = text;

    shaddow_element.style.display = '';

    setTimeout(function () {
        disable_info()
    }, duration * 1000);
}


function disable_background() {
    document.getElementById('background_shaddow').style.display = 'none';
}


function enable_background() {
    document.getElementById('background_shaddow').style.display = 'block';
}


function disable_background_full() {
    document.getElementById('background_shaddow_2').style.display = 'none';
    full_alert_is_open = false;
}


function enable_background_full() {
    document.getElementById('background_shaddow_2').style.display = 'block';
}


function disable_info() {
    document.getElementById('info_shaddow_box').style.display = 'none';
}